import {createContext} from 'react'

export const LevelContext = createContext<number | null>(null)
